module.exports = __webpack_public_path__ + "static/media/document_icon.cbfd29ae.svg";